import { api } from './networkService';

class BranchService {
    static async fetchBranches(page, filters) {
        try {
            const response = await api.get(`api/user/branch`, {
                params: {
                    page: page,
                    perPage: 20,
                    ...filters
                }
            });
            return response.data;
        } catch (error) {
            console.error('Fetch branch error:', error);
            throw error;
        }
    }

    static async fetchAll() {
        try {
            const response = await api.get(`api/user/branch`);
            return response.data;
        } catch (error) {
            console.error('Fetch branch error:', error);
            throw error;
        }
    }


    static async fetchOne(id) {
        try {
            const response = await api.get(`api/user/branch/${id}`);
            return response.data;
        } catch (error) {
            console.error('Fetch branch error:', error);
            throw error;
        }
    }


    static async addBranch(branch) {
        try {
            const cleanedBranch = Object.fromEntries(
                Object.entries(branch).filter(([_, value]) => value && value !== '')
            );
            const response = await api.post(`api/user/branch`, cleanedBranch);
            return response;
        } catch (error) {
            console.error('Add branch error:', error);
            throw error;
        }
    }

    static async updateBranch(branch) {
        try {
            const { id, ...info } = branch;
            const cleanedBranch = Object.fromEntries(
                Object.entries(info).filter(([_, value]) => value && value !== '')
            );
            const response = await api.put(`api/user/branch/${id}`, cleanedBranch);
            return response;
        } catch (error) {
            console.error('Update branch error:', error);
            throw error;
        }
    }

    static async deleteBranch(id) {
        try {
            const response = await api.delete(`api/user/branch/${id}`);
            return response;
        } catch (error) {
            console.error('Delete branch error:', error);
            throw error;
        }
    }
}

export default BranchService;
